import { HubspotForms } from "@utils";

export const SUPPORTED_DYNAMIC_FORMS = {
  "quote-spec": "ca2fde04-4942-433a-af3b-7b1426500064",
  "risk-quote-spec": "91b80b50-e7d4-48a7-90b4-ab2c4e63ab6c", // quote spec minus group health
  "health-quote-spec": "7439237a-ba88-4ad4-9a0c-e213b4e8a7a8", // quote spec with just health and dental
  "group-life-insurance": "a20480b8-0ebb-44a9-9429-1d79fe2b1495",
  "group-health-insurance": "496e9195-6ab3-4c2b-82ac-fbfa7a54a11c",
  "group-income-protection": "e56b8567-2b4b-484a-9b9c-0c6281970d57",
  "group-critical-illness": "c560beb0-0e0f-471c-98fb-d96122bd72ef",
  "group-dental-insurance": "0ccb781c-72a7-480a-8c5a-f0373465fd24",
  "get-in-touch": "f9c5979d-e2cd-4fb4-a7bb-3b9d9f22f362",
  "get-a-callback": "ffe89f26-dba2-4860-b29f-69a5fc076e99",
  "get-a-quote": "b4c17ab0-c63d-4f88-b8a6-c6eebf8fbdc2",
  "blog-signup": "7b9bbfc7-05cb-4907-9e2a-235a8383f81c",
};

export const SHORT_FORM_NAMES = {
  "a20480b8-0ebb-44a9-9429-1d79fe2b1495": "GLI",
  "496e9195-6ab3-4c2b-82ac-fbfa7a54a11c": "GHI",
  "e56b8567-2b4b-484a-9b9c-0c6281970d57": "GIP",
  "c560beb0-0e0f-471c-98fb-d96122bd72ef": "GCI",
  "0ccb781c-72a7-480a-8c5a-f0373465fd24": "GDI",
};

export const SUPPORTED_FORMS = {
  ...SUPPORTED_DYNAMIC_FORMS,
  "get-in-touch": "f9c5979d-e2cd-4fb4-a7bb-3b9d9f22f362",
  quote: "b4c17ab0-c63d-4f88-b8a6-c6eebf8fbdc2",
  "quote-US": "4e2876e6-d61e-477d-804f-50f92ef1f755",
  callback: "ffe89f26-dba2-4860-b29f-69a5fc076e99",
  "blog-sign-up": "7b9bbfc7-05cb-4907-9e2a-235a8383f81c",
  "advisor-contact-us": "5885462c-a120-4c1c-8ad3-d54e34ee3f1d",
  referral: "f3d99c38-4b37-4eed-9acd-1748fa2a0194",

  // jp forms
  "product-doc-download": "6306d6c7-20f0-48c1-8f0b-b182a7772f32",
  speakToTeamJP: "bea46b21-2e06-4836-9326-a7fdcd314c12",

  // JP instapage forms for iFrames
  "quote-JP-instapage": "83394c69-837f-4bb8-ba51-347939e441d6",
  "product-doc-download-instapage": "fe6f7572-db2f-41da-9c93-5c907cf71552",
};

export function getFormGuid(formName: HubspotForms | string) {
  // allow guid to be returned directly
  if (isGuid(formName)) {
    return formName;
  }

  switch (formName) {
    case HubspotForms.getInTouch:
      return SUPPORTED_FORMS["get-in-touch"];
    case HubspotForms.quote:
      return SUPPORTED_FORMS["quote"];
    case HubspotForms.quoteUS:
      return SUPPORTED_FORMS["quote-US"];
    case HubspotForms.speakToTeamJP:
      return SUPPORTED_FORMS["speakToTeamJP"];
    case HubspotForms.callback:
      return SUPPORTED_FORMS["callback"];
    case HubspotForms.blogSignUp:
      return SUPPORTED_FORMS["blog-sign-up"];
    case HubspotForms.adviserContactUs:
      return SUPPORTED_FORMS["advisor-contact-us"];
    case HubspotForms.productDocDownload:
      return SUPPORTED_FORMS["product-doc-download"];
    case HubspotForms.referralForm:
      return SUPPORTED_FORMS["referral"];

    // JP instapage forms for iFrames
    case HubspotForms.instapageQuoteJP:
      return SUPPORTED_FORMS["quote-JP-instapage"];
    case HubspotForms.instapageProductDocDownload:
      return SUPPORTED_FORMS["product-doc-download-instapage"];

    // dynamically built hubspot forms
    case HubspotForms.quoteSpec:
      return SUPPORTED_DYNAMIC_FORMS["quote-spec"];
    case HubspotForms.quoteSpecRisk:
      return SUPPORTED_DYNAMIC_FORMS["risk-quote-spec"];
    case HubspotForms.groupLifeInsurance:
      return SUPPORTED_DYNAMIC_FORMS["group-life-insurance"];
    case HubspotForms.groupHealthInsurance:
      return SUPPORTED_DYNAMIC_FORMS["group-health-insurance"];
    case HubspotForms.groupIncomeProtection:
      return SUPPORTED_DYNAMIC_FORMS["group-income-protection"];
    case HubspotForms.groupCriticalIllness:
      return SUPPORTED_DYNAMIC_FORMS["group-critical-illness"];
    case HubspotForms.groupDentalInsurance:
      return SUPPORTED_DYNAMIC_FORMS["group-dental-insurance"];
    case HubspotForms.quoteSpecHealth:
      return SUPPORTED_DYNAMIC_FORMS["health-quote-spec"];
    default:
      throw new Error("The provided form name cannot be found");
  }
}

function isGuid(str: string) {
  const guidRegex = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
  return guidRegex.test(str);
}
